import authRoles from '../../../auth/authRoles';
import Blog from './Blog';
import BlogPost from './BlogPost';

const BlogConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingV2',
      config: {
        header: {
          display: true
        },
        footer: {
          display: true
        }
      },
    },
  },
  auth: null, //Anyone can access regardless of logged in status
  routes: [
    {
      path: 'blog',
      element: <Blog />,
    },
    {
      path: 'blog/:slug',
      element: <BlogPost />,
    },
  ],
};

export default BlogConfig;